//@flow
export default class SortingUtil {

  static label2order = {
    DESCENDING: 1,
    ASCENDING: 0
  };

  static order2label = {
    1: 'DESCENDING',
    0: 'ASCENDING'
  };

  static criteria2OrderPreference = {
    MODIFICATION_TIME: ['OLDEST_FIRST', 'RECENT_FIRST',],
    NAME: ['ASCENDING', 'DESCENDING'],
    COLLECTION_LAST_MODIFIED: ['OLDEST','RECENT']
  };


  static order2LabelForMtime = {
    1: 'RECENT_FIRST',
    0: 'OLDEST_FIRST'
  };

  static o2L = {
    0: 'OLDEST',
    1: 'RECENT'
  }

  static label2OrderForMtime = {
    RECENT_FIRST: 1,
    OLDEST_FIRST: 0
  }
   
  static l2o = {
     OLDEST: 0,
     RECENT: 1
  }


  static getOrder2Label(order: string, criteria: ?string): string {
    if (criteria && criteria === 'MODIFICATION_TIME' || criteria === 'LATEST_FIRST') {
      return SortingUtil.order2LabelForMtime[order];
    }
    else if(criteria === 'COLLECTION_LAST_MODIFIED'){
      return SortingUtil.o2L[order];
    }
    else {
      return SortingUtil.order2label[order];
    }
  }

  static getLabel2Order(label: string, criteria: ?string): number {
    if (criteria && criteria === 'MODIFICATION_TIME' || criteria === 'LATEST_FIRST') {
      return SortingUtil.label2OrderForMtime[label];
    }
    else if(criteria === 'COLLECTION_LAST_MODIFIED'){
      return SortingUtil.l2o[label];
    }
    else {
      return SortingUtil.label2order[label];
    }
  }

  static getCriteria2OrderPreference(criteria: ?string): string[] {
    if (criteria && criteria === 'MODIFICATION_TIME' || criteria === 'LATEST_FIRST' || criteria === 'NAME' || criteria === 'COLLECTION_LAST_MODIFIED') {
      return SortingUtil.criteria2OrderPreference[criteria];
    } else {
      return ['ASCENDING', 'DESCENDING'];
    }
  }
}
